export const MONTHS = [
  "DateInputField.month.option.january",
  "DateInputField.month.option.february",
  "DateInputField.month.option.march",
  "DateInputField.month.option.april",
  "DateInputField.month.option.may",
  "DateInputField.month.option.june",
  "DateInputField.month.option.july",
  "DateInputField.month.option.august",
  "DateInputField.month.option.september",
  "DateInputField.month.option.october",
  "DateInputField.month.option.november",
  "DateInputField.month.option.december",
];
